// Queries

export const getUserProfileById = `{ 
  userProfileById {
    UserID firstName lastName nickname name email emailVerified picture organization registrationToken preferences acceptedTermsAndPrivacyPolicyTimestamp acceptedWelcomeMessageTimestamp userGroups
  } 
}`;

export const getUserGroupsById = `{
  userProfileById {
    userGroups
  }
}`;

// Mutations

export const updateUserProfile = `mutation UpdateUserProfile ($updateuserprofilesinput: UpdateUserProfilesInput!) {
  updateUserProfiles(input: $updateuserprofilesinput) {
      UserID
      firstName
      lastName
      nickname
      name
      email
      emailVerified
      picture
      organization
      registrationToken
      preferences
  }
}`;

export const updatePreferences = `mutation UpdatePreferences ($updatepreferencesinput: UpdatePreferencesInput!) { 
  updatePreferences(input: $updatepreferencesinput) { 
      firstName
      lastName
      nickname
      name
      email
      emailVerified
      picture
      organization
      registrationToken
      preferences
  } 
}`;
